import { FC } from 'react'
import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { createUseStyles } from 'react-jss'
import cx from 'classnames'

import Icon, { IconName } from './Icon'

const useStyles = createUseStyles({
  containerWithHitSlop: {
    width: 44,
    height: 44,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hidden: {
    display: 'none',
  },
})

interface Props {
  name: IconName
  className?: string
  iconClassName?: string
  onClick: () => void
  addHitSlop?: boolean
  disabled?: boolean
}

export const IconButton: FC<Props> = flowMax(
  addDisplayName('IconButton'),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({
    name,
    className,
    iconClassName,
    onClick,
    addHitSlop,
    disabled,
    classes,
  }) => (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cx(
        addHitSlop && classes.containerWithHitSlop,
        disabled && classes.hidden,
        className
      )}
    >
      <Icon name={name} className={iconClassName} />
    </button>
  )
)
